function paymentInfo(state = {}, action) {
  switch (action.type) {
    case 'PAYMENT_INFO':
      return { ...state, paymentInfo: action.paymentInfo };
    default:
      return state;
  }
}

export default paymentInfo;
